import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-accountant-customer-payouts',
  standalone: true,
  templateUrl: '../../assets/accountant-customer-payouts.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamAccountantCustomerPayoutsIcon {}
